import { pluginRegistry } from "@flow/frontend/member/plugin_api";
import useScript from "@flow/lib/use_script";
import { getSiteKey } from "../../common/routes";

pluginRegistry.registerCaptchaProvider({
  def: { provider_unique_id: "recaptcha", label: "ReCaptcha" },
  loadCaptcha: async () => {
    const site_key = (await getSiteKey.call()).site_key;
    if (site_key !== undefined) {
      await useScript(`https://www.google.com/recaptcha/api.js?render=${site_key}`);
    } else {
      // Easy fix for dev:
      // cp flow-build.config.json flow-build.config.local.json
      // Remove recaptcha from the list in flow-build.config.local.json
      console.warn("ReCaptcha plugin is enabled, but not configured. Petitions CANNOT be signed until this is fixed");
    }
  },
  captchaExecute: async (action: string): Promise<string> => {
    return new Promise((resolve, reject) => {
      if ((window as any).grecaptcha === undefined) {
        // ReCaptcha script has not finished loading, silently fail.
        // hopefully when user clicks again it will have loaded
        reject("gRecaptcha not loaded");
      }
      (window as any).grecaptcha.ready(async function () {
        (window as any).grecaptcha
          .execute((await getSiteKey.call()).site_key, { action: action })
          .then(function (token: string) {
            resolve(token);
          });
      });
    });
  },
});
